"use strict";

exports.__esModule = true;
exports.ElementEditorContextMenu = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@blueprintjs/core");
var _icons = require("@blueprintjs/icons");
var _reactIntl = require("react-intl");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var ElementEditorContextMenu = exports.ElementEditorContextMenu = /*#__PURE__*/function (_Component) {
  function ElementEditorContextMenu() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.handleSaveTemplateClick = function () {
      var _this$props = _this.props,
        path = _this$props.path,
        elementEditor = _this$props.elementEditor;
      elementEditor.openSaveTemplateDialog(path);
    };
    _this.handleChooseTemplateClick = function () {
      var _this$props2 = _this.props,
        path = _this$props2.path,
        elementEditor = _this$props2.elementEditor;
      elementEditor.openChooseTemplateDialog(path);
    };
    _this.handleDeleteClick = function () {
      var _this$props3 = _this.props,
        path = _this$props3.path,
        elementEditor = _this$props3.elementEditor;
      elementEditor.removeElementAt(path);
    };
    return _this;
  }
  _inheritsLoose(ElementEditorContextMenu, _Component);
  var _proto = ElementEditorContextMenu.prototype;
  _proto.render = function render() {
    var _this$props4 = this.props,
      intl = _this$props4.intl,
      path = _this$props4.path,
      elementEditor = _this$props4.elementEditor;
    var widget = elementEditor.getWidgetAt(path);
    return /*#__PURE__*/_react["default"].createElement(_reactIntl.IntlProvider, intl, /*#__PURE__*/_react["default"].createElement(_core.Menu, null, widget && /*#__PURE__*/_react["default"].createElement(_core.MenuDivider, {
      title: widget.label
    }), /*#__PURE__*/_react["default"].createElement(_core.MenuItem, {
      icon: _icons.IconNames.FLOPPY_DISK,
      text: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
        id: "ElementEditorContextMenu.save",
        defaultMessage: "Save Template"
      }),
      onClick: this.handleSaveTemplateClick
    }), /*#__PURE__*/_react["default"].createElement(_core.MenuItem, {
      icon: _icons.IconNames.EXCHANGE,
      text: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
        id: "ElementEditorContextMenu.replace",
        defaultMessage: "Replace With..."
      }),
      onClick: this.handleChooseTemplateClick
    }), /*#__PURE__*/_react["default"].createElement(_core.MenuDivider, null), /*#__PURE__*/_react["default"].createElement(_core.MenuItem, {
      icon: _icons.IconNames.DELETE,
      text: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
        id: "ElementEditorContextMenu.delete",
        defaultMessage: "Delete Element"
      }),
      onClick: this.handleDeleteClick,
      disabled: path.length === 0
    })));
  };
  return ElementEditorContextMenu;
}(_react.Component);